//Media Owner Dashboard
const MediaOwnerDashboard = () => import(/* webpackChunkName: "MediaOwnerDashboard" */ '../views/MediaOwner')


const MediaOwnerDashboardRouter = [
    {
        path: '/media-owner',
        name: 'mediaownerdashboard',
        component: MediaOwnerDashboard,
        meta: { isMediaOwner: true }
    }
]

export default MediaOwnerDashboardRouter;
